/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WorkorderLogItemFromJSON(json) {
    return WorkorderLogItemFromJSONTyped(json, false);
}
export function WorkorderLogItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'logId': !exists(json, 'logId') ? undefined : json['logId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'logDateTime': !exists(json, 'logDateTime') ? undefined : (new Date(json['logDateTime'])),
        'logUser': !exists(json, 'logUser') ? undefined : json['logUser'],
        'logActivity': !exists(json, 'logActivity') ? undefined : json['logActivity'],
    };
}
export function WorkorderLogItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'logId': value.logId,
        'workorderId': value.workorderId,
        'logDateTime': value.logDateTime === undefined ? undefined : (value.logDateTime.toISOString()),
        'logUser': value.logUser,
        'logActivity': value.logActivity,
    };
}
